import { Box } from "@mui/material"
import { styled } from "@mui/system"
import { FC, useEffect, useMemo, useState } from "react"
import { useScoreData } from "../../score/context/ScoreProvider"
import { MapChapterProps } from "../Map"
import { PoiPlacement, getBackgroundImg, poisList } from "../MapDatas"
import { MapChapterHeader } from "../components/MapChapterHeader"
import { MapChapterPoi } from "../components/MapChapterPoi"

export const MapChapter: FC<MapChapterProps> = ({ chapterPath, color }) => {
  //  CONTEXTS
  const { progression, chapters } = useScoreData()

  //  LOGIC
  const [backgroundImg] = useState(getBackgroundImg(chapterPath))

  const [windowHeight, setWindowHeight] = useState<number>(window.innerHeight)

  const handleResize = () => {
    setWindowHeight(window.innerHeight)
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const POIsRender = useMemo(() => {
    return poisList[chapterPath].map((id, i) => (
      <MapChapterPoi
        key={`poi-${id}`}
        {...{
          id,
          index: i,
          color,
          position: PoiPlacement[i],
          chapters,
          progression,
        }}
      />
    ))
  }, [chapterPath, color, progression, chapters])

  return (
    <>
      <MapChapterBackground
        backgroundimg={backgroundImg}
        sx={{
          transform: `translate(-50%, -50%) scale(${windowHeight / 750})`,
        }}
      >
        {POIsRender}
      </MapChapterBackground>

      <MapChapterHeader {...{ chapterPath, color }} />
    </>
  )
}

//  STYLED
const MapChapterBackground = styled(Box)<{ backgroundimg: string }>(
  ({ backgroundimg }) => ({
    // backgroundColor: "transparent",
    position: "absolute",
    top: "60%",
    left: "50%",
    width: "700px",
    height: "700px",
    backgroundImage: `url(${backgroundimg})`,
    backgroundSize: "100% 100%",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  })
)
